export default __webpack_public_path__ + "static/media/lunarTitle.8673787d.png";